import { AppRouterProps } from "./AppRouterProps";
import { Router } from "@mcleod/common";

export class AppRouter extends Router {
    constructor(props: Partial<AppRouterProps>) {
        super(props);
    }

    public override get defaultRouterPadding(): number {
        return 0;
    }

    static get instance(): AppRouter {
        if (Router.instance == null)
            new AppRouter({}); // The parent will set its own ._instance value.
        return Router.instance as AppRouter;
    }
}
